import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { connect } from 'react-redux';
import { GREEN, RED, SUBSCRIPTION_TYPES } from '../../../_config/consts';
import { localizeHelpCenterLink } from '../../../_config/utils.js';
import * as ModalActions from '../../../redux/actions/modal.actions';
import * as UserActions from '../../../redux/actions/user.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import CheckOutlineIconCustom from '../../CustomIcons/CheckOutlineIconCustom.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import { IconButton } from '@material-ui/core';
import CopyIconCustom from '../../CustomIcons/CopyIconCustom.jsx';
import { submit } from 'redux-form';
import FormFlatContainer from '../../forms/Elements/FormFlatContainer.jsx';
import DuveActivationForm from '../../forms/Integrations/DuveActivationForm.jsx';


@connect(state => ({ language: state.settings.language, integrations: state.user.activeIntegration, form: state.form.DuveActivationForm }))
class DuveSettingsOperationalSection extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      isActive: null,
      additionalInfo: null
    };
  }

  async componentDidMount() {
    const { dispatch } = this.props;
    const isActive = dispatch(UserActions.userHasIntegrationActive(SUBSCRIPTION_TYPES.DUVE_INTEGRATION));
    const additionalInfo = dispatch(UserActions.getIntegrationAdditionalInfo(SUBSCRIPTION_TYPES.DUVE_INTEGRATION));
    this.setState({ isActive, additionalInfo });
  }


  onDeactivateIntegrationRequest() {
    const { dispatch } = this.props;
    const params = {
      modalType: 'CONFIRM_TO_CONTINUE_MODAL',
      modalProps: {
        title: 'confirmBeforeContinue',
        body: <Entity entity="disableIntegrationConfirm" />,
        onConfirmText: <Entity entity="yes" />,
        onConfirm: () => this.onDeactivateIntegration(),
        onCancelText: <Entity entity="no" />,
        onCancel: () => dispatch(ModalActions.hideModal()),
      },
    };
    dispatch(ModalActions.showModal(params));
  }

  async onDeactivateIntegration() {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const deactivationDTO = dispatch(UserActions.getActiveIntegration(SUBSCRIPTION_TYPES.DUVE_INTEGRATION));
      if (deactivationDTO && deactivationDTO.id) {
        await dispatch(UserActions.disableIntegration(deactivationDTO.id));
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(UserActions.fetchCurrentActiveIntegrations());
        this.setState({ isActive: false });
        dispatch(ModalActions.showModal({
          modalType: 'SUCCESS_ALERT',
          modalProps: {
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedSuccess" /></h6>),
          },
        }));
      } else {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        dispatch(ModalActions.showModal({
          modalType: 'ERROR_ALERT',
          modalProps: {
            anchorOrigin: { vertical: 'top', horizontal: 'center' },
            message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
          },
        }));
      }
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  onOpenActivationInfo() {
    const helpURL = localizeHelpCenterLink('duve-integration-activation-steps');
    window.open(helpURL);
  }

  onGoBackToLogin() {
    this.setState({ resourceTypes: null, optixToken: null })
  }

  async onActivateIntegration(integrationData) {
    const { dispatch } = this.props;
    dispatch(UtilsActions.setSpinnerVisibile(true));
    try {
      const reservationsSyncMode = []

      const isPINactive = integrationData.pin;
      const isCredentialRuleActive = integrationData.credentialRule;
      const isInvitationActive = integrationData.invitation;

      const duveconnectPid = integrationData.duveconnectPid || undefined;
      const duveconnectToken = integrationData.duveconnectToken || undefined;
      const duveInvitationUrlField = integrationData.duveInvitationUrlField || undefined;

      const sendPinToDuve = isPINactive && integrationData.sendPinToDuve;
      const sendInvitationToDuve = isInvitationActive && integrationData.sendInvitationToDuve && duveInvitationUrlField;

      const reservationStatusesToSync = integrationData.statuses || [];

      const resourcesToSync = integrationData.rooms && integrationData.rooms.length > 0 && integrationData.rooms[0] ? integrationData.rooms : [];

      const dontSendUserActivationEmail = integrationData.dontSendUserActivationEmail || false;

      if (isPINactive) {
        reservationsSyncMode.push("PIN");
      }
      if (isCredentialRuleActive) {
        reservationsSyncMode.push("CREDENTIAL_RULE")
      }
      if (isInvitationActive) {
        reservationsSyncMode.push("INVITATION")
      }
      if (reservationsSyncMode.length === 0) {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        return
      }
      if (reservationStatusesToSync.length === 0) {
        dispatch(UtilsActions.setSpinnerVisibile(false));
        return
      }
      const activationDataParsed = {
        ...integrationData,
        reservationsSyncMode,
        duveconnectPid,
        duveconnectToken,
        timeZone: integrationData.timezone,
        reservationStatusesToSync,
        resourcesToSync,
        sendPinToDuve,
        dontSendUserActivationEmail,
        duveInvitationUrlField: sendInvitationToDuve ? duveInvitationUrlField : undefined,

        sendInvitationToDuve: undefined,
        pin: undefined,
        credentialRule: undefined,
        invitation: undefined,
        timezone: undefined,
        statuses: undefined,
        rooms: undefined,
      }
      await dispatch(UserActions.activateDuveIntegration(activationDataParsed));
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(UserActions.fetchCurrentActiveIntegrations());
      this.setState({ isActive: true });
      dispatch(ModalActions.showModal({
        modalType: 'SUCCESS_ALERT',
        modalProps: {
          message: (<h6 className="snack-title"><Entity entity="integrationActivateSuccess" /></h6>),
        },
      }));
    } catch (error) {
      dispatch(UtilsActions.setSpinnerVisibile(false));
      dispatch(ModalActions.showModal({
        modalType: 'ERROR_ALERT',
        modalProps: {
          anchorOrigin: { vertical: 'top', horizontal: 'center' },
          message: (<h6 className="snack-title"><Entity entity="integrationDeactivatedError" /></h6>),
        },
      }));
    }
  }

  render() {
    const { isActive, additionalInfo } = this.state;
    const { dispatch } = this.props;

    const reservationCreatedUrl = (additionalInfo?.url || '') + '/reservationCreated';
    const reservationStatusUrl = (additionalInfo?.url || '') + '/reservationStatus';
    const reservationRoomUrl = (additionalInfo?.url || '') + '/reservationRoom';

    return (
      <div style={{ paddingLeft: 20, paddingRight: 25, paddingTop: 10, display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
        <img alt="duve" src="/imgs/common/integrationLogos/duve-logo.png" style={{ height: 70, alignSelf: 'center' }} />
        {isActive ? (
          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'center', paddingLeft: 25, paddingRight: 25, flexDirection: 'column'}}>
            <div style={{ width: '70%', margin: 'auto', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
              <CheckOutlineIconCustom style={{ color: GREEN, width: 30, marginRight: 10 }} />
              <h4 style={{ color: GREEN, fontWeight: 'bold', fontSize: 20 }}><Entity entity="integrationCorrectlyConfigured" /></h4>
            </div>
            {additionalInfo && additionalInfo.url ?  (
              <FormFlatContainer
                title="integrationAdditionalInfo"
                subtitle="passValuesToDuve"
                subtitleStyle={{ fontSize: 18, marginLeft: 0 }}
                titleStyle={{ marginLeft: 0 }}
                headerStyle={{ marginBottom: 20 }}
              >
                <div>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="reservationCreatedDuveWebhookUrl" /></h4>
                  <h4 style={{ marginTop: 0 }}>{reservationCreatedUrl} <CopyToClipboard text={reservationCreatedUrl}>
                  <IconButton>
                    <CopyIconCustom style={{ width: 20, color: '#3f3f3f' }} />
                  </IconButton>
                  </CopyToClipboard></h4>
                </div>
                <div>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="reservationStatusDuveWebhookUrl" /></h4>
                  <h4 style={{ marginTop: 0 }}>{reservationStatusUrl} <CopyToClipboard text={reservationStatusUrl}>
                  <IconButton>
                    <CopyIconCustom style={{ width: 20, color: '#3f3f3f' }} />
                  </IconButton>
                  </CopyToClipboard></h4>
                </div>
                <div>
                  <h4 style={{ marginBottom: 0, fontWeight: 'bold' }}><Entity entity="reservationRoomDuveWebhookUrl" /></h4>
                  <h4 style={{ marginTop: 0 }}>{reservationRoomUrl} <CopyToClipboard text={reservationRoomUrl}>
                  <IconButton>
                    <CopyIconCustom style={{ width: 20, color: '#3f3f3f' }} />
                  </IconButton>
                  </CopyToClipboard></h4>
                </div>
              </FormFlatContainer>
            ): null}
            <MDButton
              title={<Entity key={isActive} entity="disableIntegrationTitle" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={RED}
              containerStyle={{ margin: 'auto', marginTop: 20, width: '80%' }}
              onClick={() => this.onDeactivateIntegrationRequest()}
            />
          </div>
        ) : (
            <div style={{ width: '70%', margin: 'auto', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <h4 style={{ margin: 0, marginTop: 20, marginBottom: 10 }}><Entity style={{ fontWeight: 'bold' }} entity="activateIntegrationTitle" data={{ integrationName: 'duve'}} /></h4>
            <h4 style={{ margin: 0, textAlign: 'center', marginBottom: 20 }}><Entity entity="activateTenupIntegrationDescription" data={{ integrationName: 'duve'}} /></h4>
            <DuveActivationForm
              onSubmit={(integrationData) => this.onActivateIntegration(integrationData)}
            />
            <MDButton
              title={<Entity key={isActive} entity="activate" />}
              titleStyle={{ marginTop: 0, fontSize: 13 }}
              backgroundColor={GREEN}
              containerStyle={{ margin: 0, marginTop: 20, width: '80%' }}
              onClick={() => dispatch(submit('DuveActivationForm'))}
            />
            </div>
          )}
          <h5
            className="link-label"
            style={{ margin: 'auto', width: 'fit-content', marginTop: 20, fontSize: 16, textDecoration: 'underline' }}
            onClick={() => this.onOpenActivationInfo()}
          >
            <Entity entity="findOutMore" />
          </h5>
      </div>
    );
  }
}

export default DuveSettingsOperationalSection;
